import React from 'react';
import ActivityCard from '../components/layout/ActivityCard';
import { getActivityByID, getLeadByID } from '../services/api/implementation/impl';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const ActivityList = ({ salesId }) => {
  const userId = Cookies.get('userId');
  const { id } = useParams();

  const ID = salesId ? salesId : id;
  const {
    data: activityId,
    isLoading,
    error,
    refetch: refetchLeadbyId
  } = useQuery({
    queryKey: ['activityById', parseInt(ID)],
    queryFn: async () => {
      const res = await getActivityByID(parseInt(ID));
      return res;
    },
    enabled: !!ID // Only run the query if id is truthy
  });

  console.log({ activityId });
  /*
    Meta data
  */

  /* 
    JSX
  */
  return (
    <div className="flex flex-col bg-white shadow-lg rounded-lg mt-[0.5rem] w-[100%] mx-auto p-6">
      <span className="text-lg font-semibold">Stages</span>

      <div className="w-full flex flex-col justify-between items-center gap-8 mt-10">
        {Array.isArray(activityId) &&
          activityId.map((item, index) => (
            <ActivityCard key={index} special={index === 0} data={item} />
          ))}
      </div>
    </div>
  );
};

export default ActivityList;
